// src/i18n.js

// שפות נתמכות
export const SUPPORTED_LANGS = ["he", "en", "es"];

export const LANGUAGE_LABELS = {
  he: "עברית",
  en: "English",
  es: "Español",
};

// נרמול שפה שמגיעה מה־URL או מהדפדפן
export function normalizeLang(raw) {
  if (!raw) return "he";
  const v = String(raw).toLowerCase();
  if (v.startsWith("he")) return "he";
  if (v.startsWith("en")) return "en";
  if (v.startsWith("es")) return "es";
  return SUPPORTED_LANGS.includes(v) ? v : "he";
}

// כיוון כתיבה לפי שפה
export function dirForLang(lang) {
  const code = normalizeLang(lang);
  return code === "he" ? "rtl" : "ltr";
}

/**
 * פונקציית תרגום גנרית.
 *
 * שימוש אפשרי 1 – אובייקט:
 *   t("he", { he: "שלום", en: "Hello", es: "Hola" })
 *
 * שימוש אפשרי 2 – שלושה מחרוזות:
 *   t(lang, "שלום", "Hello", "Hola")
 */
export function t(lang, textOrObj, enText, esText) {
  const code = normalizeLang(lang);

  // צורה 1: אובייקט {he, en, es}
  if (textOrObj && typeof textOrObj === "object" && !enText && !esText) {
    const m = textOrObj;
    return m[code] || m.he || m.en || m.es || "";
  }

  // צורה 2: שלוש מחרוזות
  if (typeof textOrObj === "string") {
    const heText = textOrObj;
    const en = enText || heText;
    const es = esText || heText;

    if (code === "he") return heText;
    if (code === "en") return en;
    if (code === "es") return es;
    return heText;
  }

  return "";
}
